import { AI_POSITIONING } from "../content";
import { AiSectionHead, AiRichText } from "./AiSection";

/** 方案定位：L1/L2/L3 三级融合深度 + 结论提示条。对应设计稿第 3 节。 */
export default function AiPositioning() {
  return (
    <section aria-labelledby="ai-positioning-h" className="py-14 lg:py-20">
      <div className="rounded-3xl bg-[#f8fafc] border border-gray-100 px-6 lg:px-10 py-12 lg:py-16">
        <AiSectionHead eyebrow={AI_POSITIONING.eyebrow} title={AI_POSITIONING.title} sub={AI_POSITIONING.sub} />
        <div className="grid gap-6 md:grid-cols-3">
          {AI_POSITIONING.cards.map((c) => (
            <article
              key={c.badge}
              className="bg-white border border-gray-200 rounded-2xl p-6 lg:p-8 transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(13,31,60,0.12)] hover:border-[#1a56db]/30"
            >
              <span className="inline-grid place-items-center w-[30px] h-[30px] rounded-md font-mono text-xs font-bold bg-[#1a56db] text-white mb-4">
                {c.badge}
              </span>
              <h3 className="text-lg font-bold text-[#0d1f3c] mb-3">{c.title}</h3>
              <p className="m-0 text-sm text-[#475569] leading-relaxed">{c.desc}</p>
            </article>
          ))}
        </div>
        <AiRichText
          segments={AI_POSITIONING.note}
          className="mt-8 p-5 lg:px-6 rounded-[10px] bg-white border border-gray-200 border-l-4 border-l-[#1a56db] text-sm text-[#475569] leading-[1.8]"
        />
      </div>
    </section>
  );
}
